import Header from "./header";
import SideBar from "./sidebar";
import Footer from "./footer";
import MobileHeader from "./MobileHeader";
import useIsMobile from "../hooks/useIsMobile";

// A line is a section heading if it's "I. …", "II. …" etc.
const isRomanHeading = (line) => /^[IVXLCDM]+\.\s/.test(line);
// …or a short ALL-CAPS line (document title / caps sub-heading).
const isCapsHeading = (line) => {
    const letters = line.replace(/[^A-Za-z]/g, "");
    return letters.length > 4 && line.length < 80 && line === line.toUpperCase();
};

const renderBlocks = (content) =>
    content.map((line, i) => {
        if (isRomanHeading(line)) return <h3 key={i} className="lh">{line}</h3>;
        if (isCapsHeading(line)) return <h4 key={i} className="lsub">{line}</h4>;
        return <p key={i} className="lp">{line}</p>;
    });

const LegalPage = ({ title, content }) => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <>
                <SideBar />
                <main className="mlux mlux-auth">
                    <MobileHeader back="/" />
                    <div className="mlux-greet" style={{ margin: "8px 4px 6px" }} data-rise="1">
                        <div className="kick">Legal</div>
                        <div className="nm" style={{ fontSize: 24 }}>{title}</div>
                    </div>
                    <div className="mlux-card mlux-legal" style={{ padding: 16 }} data-rise="2">
                        {renderBlocks(content)}
                    </div>
                </main>
            </>
        );
    }

    return (
        <>
            <Header />
            <SideBar />
            <main className="main">
                <div className="site-breadcrumb" style={{ background: "url(/assets/img/breadcrumb/01.jpg)" }}>
                    <div className="container">
                        <h2 className="breadcrumb-title">{title}</h2>
                    </div>
                </div>
                <div className="py-120">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="terms-content mlux-legal">{renderBlocks(content)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default LegalPage;
